<template>
  <div>
    <Header />
    <main role="main" class="auth">
      <b-container>
        <b-row>
          <b-col md="6" class="d-block-md"  style="margin-top:2%">
            
          </b-col>
          <b-col class="pt-3" xs="12" md="6">
            <slot />
          </b-col>
        </b-row>
      </b-container>
    </main>
    <Footer />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Footer from '@/components/Footer'

export default {
  components: {
    Header,
    Footer
  }
}
</script>